import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 1 }

import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {Finance as FinanceClient} from "@/endpoints/rutsolve/gql/resolvers/finance"
  import {ref} from "vue"
  import {FinanceResponse} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import DateInput from "@/components/inputs/date.vue"
  import Button from "@/components/button.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'finances',
  setup(__props) {

  const error = ref<Error>(null)
  const financeClient = new FinanceClient()
  const finances = ref<FinanceResponse>(null)
  const periodEnd = ref<string>(null)
  const periodStart = ref<string>(null)

  async function read() {
    try {
      finances.value = await financeClient.overview({
        periodEnd: periodEnd.value,
        periodStart: periodStart.value,
      })
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }],
            title: "Finances"
          }),
          _cache[13] || (_cache[13] = _createElementVNode("h1", null, " Finances ", -1)),
          _createVNode(DateInput, {
            value: periodStart.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((periodStart).value = $event)),
            title: "Period Start"
          }, null, 8, ["value"]),
          _createVNode(DateInput, {
            value: periodEnd.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((periodEnd).value = $event)),
            title: "Period End"
          }, null, 8, ["value"]),
          _createVNode(Button, {
            title: "Load Finances",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (read()))
          }),
          (error.value)
            ? (_openBlock(), _createBlock(ErrorModal, {
                key: 0,
                error: error.value,
                "onUpdate:error": _cache[3] || (_cache[3] = ($event: any) => ((error).value = $event))
              }, null, 8, ["error"]))
            : _createCommentVNode("", true),
          (finances.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[11] || (_cache[11] = _createElementVNode("h2", null, " Overview ", -1)),
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("th", null, " Gross Profit ", -1)),
                      _createElementVNode("td", null, [
                        (finances.value.profitGross)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(finances.value.profitGross.toFixed(2)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("th", null, " Net Profit ", -1)),
                      _createElementVNode("td", null, [
                        (finances.value.profitNet)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(finances.value.profitNet.toFixed(2)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("th", null, " Gross Revenue ", -1)),
                      _createElementVNode("td", null, [
                        (finances.value.revenueGross)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(finances.value.revenueGross.toFixed(2)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("th", null, " Net Revenue ", -1)),
                      _createElementVNode("td", null, [
                        (finances.value.revenueNet)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(finances.value.revenueNet.toFixed(2)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("th", null, " Gross Cost ", -1)),
                      _createElementVNode("td", null, [
                        (finances.value.costGross)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(finances.value.costGross.toFixed(2)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("th", null, " Net Cost ", -1)),
                      _createElementVNode("td", null, [
                        (finances.value.costNet)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(finances.value.costNet.toFixed(2)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("h2", null, " VAT ", -1)),
                _createElementVNode("table", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, " Rate "),
                      _createElementVNode("th", null, " Revenue "),
                      _createElementVNode("th", null, " Cost ")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finances.value.vat, (vat) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: vat.rate
                      }, [
                        _createElementVNode("td", null, [
                          (vat.rate)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(vat.rate.toFixed(2)) + "% ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          (vat.revenue)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(vat.revenue.toFixed(2)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          (vat.cost)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(vat.cost.toFixed(2)), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})